import { z } from 'zod'
import { Currency } from '../../../enums/currency.enum'
import { isoDate } from '../expenses-by-category/iso-date'

// incomes are always tied to a real category (Income.categoryId is NOT NULL and
// has no per-split override), so the drill-down only accepts a category uuid.
export const categoryIncomesQuerySchema = z
  .object({
    categoryId: z.string().guid(),
    from: isoDate,
    to: isoDate,
    baseCurrency: z.nativeEnum(Currency).optional(),
  })
  .refine((q) => q.from <= q.to, { message: 'from must be on or before to', path: ['from'] })

export type CategoryIncomesQueryDto = z.infer<typeof categoryIncomesQuerySchema>

export const categoryIncomesItemSchema = z.object({
  id: z.string().guid(),
  date: z.string(),
  description: z.string().nullable(),
  amount: z.number(),
  currency: z.string(),
  convertedAmount: z.number(),
  accountId: z.string().guid(),
  accountName: z.string(),
})

export type CategoryIncomesItemDto = z.infer<typeof categoryIncomesItemSchema>

export const categoryIncomesResponseSchema = z.object({
  baseCurrency: z.nativeEnum(Currency),
  categoryId: z.string().guid(),
  items: z.array(categoryIncomesItemSchema),
  skippedIncomeCount: z.number().int().nonnegative(),
})

export type CategoryIncomesResponseDto = z.infer<typeof categoryIncomesResponseSchema>
